import { render, staticRenderFns } from "./PerformanceElectricCarousel.vue?vue&type=template&id=c58597b2&scoped=true&"
import script from "./PerformanceElectricCarousel.vue?vue&type=script&lang=js&"
export * from "./PerformanceElectricCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58597b2",
  null
  
)

export default component.exports